import { partnerClient as api } from '@modules/core/services';

import { PatientHistory, PatientProfileResponse, UseQueryPatientProfileParams } from '../types';
import { UpdatePatientProfileParams } from '../components/shared/ProfileDetails/ProfileDetails.type';
import {
  CreateReferralResponse,
  CreateReferralValues,
} from '../views/CreatePatientReferralScreen/CreatePatientReferralScreen.types';

const PATH = `appointments`;

export const fetchPatientProfile = async ({ id }: UseQueryPatientProfileParams): Promise<PatientProfileResponse> => {
  const url = id ? `${PATH}/${id}` : PATH;

  return await api.get(url);
};

export const updatePatientProfile = async ({ id, params }: UpdatePatientProfileParams): Promise<void> => {
  const url = `${PATH}/${id}`;

  return await api.patch(url, params);
};

export const createReferral = async (params: CreateReferralValues): Promise<CreateReferralResponse> => {
  const response = await api.post(`${PATH}/create`, params);

  return response?.data;
};

export const getPatientHistory = async ({ id }: { id: string }): Promise<PatientHistory[]> => {
  const url = `/appointment_history/${id}`;

  return await api.get(url);
};
